import List from 'containers/Contacts/List';
import Edit from 'containers/Contacts/Edit';
import Create from 'containers/Contacts/Create';
import Show from 'containers/Contacts/Show';

export default { List, Edit, Create, Show };
